import { ButtonSecondary, Colors, Icon, Pills, Text } from '@amelio/ui-library';

import { EvaluationType } from '@/constants/cycle-evaluation/CycleEvaluation';
import { CycleInstanceSteps } from '@/constants/cycle-evaluation/CycleInstanceSteps';
import { useAmelioTranslations } from '@/hooks';
import { useCanStartEvaluations } from '@/hooks/evaluations/useCanStartEvaluations';
import { useStartEvaluation } from '@/hooks/evaluations/useStartEvaluation';

/** What the reader can do once a feedback closed short of its minimum. */
export const NextSteps = ({ revieweeId }: { revieweeId: string }) => {
    const { t } = useAmelioTranslations();
    const canStartEvaluations = useCanStartEvaluations();
    const { start, isCreating } = useStartEvaluation({
        evaluationType: EvaluationType.EVALUATION_360,
        firstStep: CycleInstanceSteps.ASSIGN_REVIEWER,
    });

    return (
        <div
            className={
                'border-base-200 mt-2 flex w-full flex-col items-center gap-2.5 border-t pt-4.5'
            }
        >
            <Text
                size={'small'}
                weight={'semibold'}
                color={Colors.BASE_600}
            >
                {t('results.belowThreshold.nextSteps.title')}
            </Text>

            <div
                className={
                    'flex w-full flex-col items-center gap-2.5 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-4.5'
                }
            >
                {canStartEvaluations && (
                    <ButtonSecondary
                        wrap
                        className={'max-w-full'}
                        disabled={isCreating}
                        onClick={() => start(revieweeId)}
                        leftIcon={
                            <Icon
                                name={'essential-add'}
                                className={'mr-2'}
                            />
                        }
                    >
                        {t('results.belowThreshold.nextSteps.launchNew')}
                    </ButtonSecondary>
                )}

                {/* Announced, not offered yet: plain text, so no control sits there doing nothing. */}
                <Text
                    size={'small'}
                    color={Colors.BASE_400}
                    className={'inline-flex flex-wrap items-center justify-center gap-2'}
                >
                    {t('results.belowThreshold.nextSteps.reopen')}

                    <Pills
                        variant={'default'}
                        size={'sm'}
                    >
                        {t('results.belowThreshold.nextSteps.soon')}
                    </Pills>
                </Text>
            </div>
        </div>
    );
};
